// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NVgLsCfmkc_eQyHk2VCt4 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}", "",{"version":3,"sources":["webpack://./src/components/app/news/ArticleList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;AACpC","sourcesContent":[".Container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": "NVgLsCfmkc_eQyHk2VCt4"
};
export default ___CSS_LOADER_EXPORT___;
